import { z } from 'zod';

// Unix time(ms)
export const timestampSchema = z.number().int().nonnegative();

export type Timestamp = z.infer<typeof timestampSchema>;
